/* React */
import React from "react";

/* Ionic */
import { IonCard, IonCardTitle } from "@ionic/react";

/* Stylesheet */
import styles from "./GlossaryEntry.module.scss";

/* Interfaces */
import { GlossaryProps } from "src/shared/interfaces/common/Glossary";

const GlossaryEntry: React.FC<{ entry: GlossaryProps }> = ({
  entry,
}) => {
  return (
    <IonCard className={styles.glossary_entry} button>
      <IonCardTitle className={styles.title}>
        {entry.name}
      </IonCardTitle>
      <div
        className={styles.content}
        dangerouslySetInnerHTML={{
          __html: entry.description,
        }}
      />
    </IonCard>
  );
};

export default GlossaryEntry;
